import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogIn, Mail, Lock, UserPlus } from "lucide-react";
import PageTransition from "../components/PageTransition";
import { useCustomerAuth } from "../context/CustomerAuthContext";
import { toast } from "sonner";

const formatError = (e) => {
    const d = e?.response?.data?.detail;
    if (!d) return "Bir hata oluştu";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || "Doğrulama hatası";
    return String(d);
};

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useCustomerAuth();
    const [form, setForm] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(form.email, form.password);
            toast.success("Hoş geldiniz!");
            const back = location.state?.from || "/profile";
            navigate(back);
        } catch (err) {
            toast.error(formatError(err));
        } finally { setLoading(false); }
    };

    return (
        <PageTransition>
            <div className="max-w-md mx-auto px-6 py-24">
                <div className="ornament-divider mb-6"><span className="font-arabic text-2xl text-gold">۞</span></div>
                <h1 className="font-serif text-4xl text-center mb-2">Hesabınıza Giriş Yapın</h1>
                <p className="text-center text-muted_green text-sm mb-8">Rezervasyonlarınızı ve yorumlarınızı tek panelden yönetin.</p>
                <form onSubmit={submit} className="space-y-4 border border-border_green bg-emerald_surface p-6" data-testid="login-form">
                    <div>
                        <label className="label-dark flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-gold" /> E-posta</label>
                        <input type="email" required className="input-dark" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email" />
                    </div>
                    <div>
                        <label className="label-dark flex items-center gap-2"><Lock className="w-3.5 h-3.5 text-gold" /> Şifre</label>
                        <input type="password" required className="input-dark" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password" />
                    </div>
                    <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="login-submit">
                        <LogIn className="w-4 h-4" /> {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
                    </button>
                    <div className="text-center text-sm text-muted_green pt-2 border-t border-border_green">
                        Hesabınız yok mu? <Link to="/register" className="text-gold hover:underline font-semibold" data-testid="goto-register"><UserPlus className="w-3.5 h-3.5 inline" /> Üye Olun</Link>
                    </div>
                </form>
            </div>
        </PageTransition>
    );
};

export default Login;
